<template>
  <h2 class="product-slider-title">
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'ProductSliderTitle',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.product-slider-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 125%;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 16px;
  @include point-md {
    font-size: 20px;
  }
  @include point-lg {
    font-size: 24px;
    margin-bottom: 24px;
  }
}
</style>
